<template>
  <div class="aboutus-container">
    <div class="banner-container">
      <div class="banner-content">
        <div class="banner-title">腾讯优图</div>
        <div class="banner-theme">你身边的视觉AI专家</div>

      </div>
    </div>
    <div class="youtu-profile-container">
      <div class="youtu-profile-content">
        <div class="youtu-profile">
          <div class="profile-title">优图简介</div>
          <div class="profile-info">
            <p>腾讯优图实验室成立于2012年，是腾讯公司旗下顶级人工智能实验室。优图聚焦计算机视觉，专注人脸识别、图像识别、OCR等领域开展技术研发和行业落地，在推动产业数字化升级过程中，优图始终专注基础研究、产业落地两条腿走路的发展战略，与腾讯云与智慧产业深度融合，挖掘客户痛点，切实为行业降本增效。</p>
            <p>与此同时，优图关注科技的社会价值，践行科技向善理念，致力于通过视觉AI技术解决社会问题，帮助弱势群体。</p>
          </div>
        </div>
        <div class="youtu-video">
          <video class="player" controls="controls" poster="./img/img_aboutus_video.jpg">
              <source type="video/mp4" src="/static/files/mp4file/youtu_new_intro.mp4">
          </video>
        </div>
      </div>
    </div>
    <div class="development-course-container">
      <div class="development-course">
        <div class="module-title">发展历程</div>
        <div class="development-course-content" :style="{left: honorLeft + 'px'}">
          <div class="development-course-item" :class="{'year-hidden': yearActive < 2024}">
            <div class="year">2024年</div>
            <div class="info">
              <div class="text-li">
                <div class="date">2024.7</div>
                <div class="content">开源全球最大甲骨文多模态数据集</div>
              </div>
              <div class="text-li">
                <div class="date">2024.5</div>
                <div class="content">发布国内首个汽车大模型标准</div>
              </div>
              <div class="text-li">
                <div class="date">2024.4</div>
                <div class="content">发布行业首个数字人金融应用技术指南</div>
              </div>
            </div>
          </div>
          <div class="development-course-item" :class="{'year-hidden': yearActive < 2023}">
            <div class="year">2023年</div>
            <div class="info">
              <div class="text-li">
                <div class="date">2023.12</div>
                <div class="content">入选2023中国技术品牌影响力企业榜单</div>
              </div>
              <div class="text-li">
                <div class="date">2023.11</div>
                <div class="content">世界互联网领先科技成果大奖</div>
              </div>
              <div class="text-li">
                <div class="date">2023.6</div>
                <div class="content">CVPR 2023 视觉异常检测挑战赛冠军</div>
              </div>
              <div class="text-li">
                <div class="date">2023.6</div>
                <div class="content">Gartner报告计算机实际应用中国第一</div>
              </div>
            </div>
          </div>
          <div class="development-course-item" :class="{'year-hidden': yearActive < 2022}">
            <div class="year">2022年</div>
            <div class="info">
              <div class="text-li">
                <div class="date">2022.9</div>
                <div class="content">腾讯「探星计划」荣获SAIL之星</div>
              </div>
              <div class="text-li">
                <div class="date">2022.6</div>
                <div class="content">获CVPR 2022 CLEAR Challenge持续学习重磅比赛第一名</div>
              </div>
              <div class="text-li">
                <div class="date">2022.5</div>
                <div class="content">斩获2022数博会领先科技成果奖</div>
              </div>
            </div>
          </div>
          <div class="development-course-item" :class="{'year-hidden': yearActive < 2021}">
            <div class="year">2021年</div>
            <div class="info">
              <div class="text-li">
                <div class="date">2021.10</div>
                <div class="content">视觉AI能力获IDC认可，位列中国厂商战略维度No.1</div>
              </div>
              <div class="text-li">
                <div class="date">2021.10</div>
                <div class="content">ICCV2021 LVIS Challenge Workshop冠军及最佳创新奖</div>
              </div>
              <div class="text-li">
                <div class="date">2021.08</div>
                <div class="content">CVPR2021 Image Matching Workshop 新纪录</div>
              </div>
              <div class="text-li">
                <div class="date">2021.04</div>
                <div class="content">NTIRE视频空间超分和时空超分双赛道冠亚军</div>
              </div>
              <div class="text-li">
                <div class="date">2021.01</div>
                <div class="content">NWPU No.1</div>
              </div>
            </div>
          </div>
          <div class="development-course-item" :class="{'year-hidden': yearActive < 2020}">
            <div class="year">2020年</div>
            <div class="info">
              <div class="text-li">
                <div class="date">2020.9</div>
                <div class="content">NTIRE 真实图像超分比赛No.1</div>
              </div>
              <div class="text-li">
                <div class="date">2020.9</div>
                <div class="content">HiEve 多目标跟踪（MOT）挑战赛挑战赛NO.1</div>
              </div>
              <div class="text-li">
                <div class="date">2020.9</div>
                <div class="content">深圳人工智能展获颁 AI Star 奖项</div>
              </div>
              <div class="text-li">
                <div class="date">2020.7</div>
                <div class="content">IJCAI 2020 挑战赛NO.1</div>
              </div>
              <div class="text-li">
                <div class="date">2020.6</div>
                <div class="content">开源移动端推理框架 TNN</div>
              </div>
              <div class="text-li">
                <div class="date">2020.5</div>
                <div class="content">FaceForensics Benchmark 新纪录</div>
              </div>
            </div>
          </div>
          <div class="development-course-item" :class="{'year-hidden': yearActive < 2019}">
            <div class="year">2019年</div>
            <div class="info">
              <div class="text-li">
                <div class="date">2019.09</div>
                <div class="content">ActivityNet-1.3<br/>THUMOS14</div>
              </div>
              <div class="text-li">
                <div class="date">2019.04</div>
                <div class="content">DSFD算法开源</div>
              </div>
            </div>
          </div>
          <div class="development-course-item" :class="{'year-hidden': yearActive < 2018}">
            <div class="year">2018年</div>
            <div class="info">
              <div class="text-li">
                <div class="date">2018.10</div>
                <div class="content">WiderFace No.1<br/>FDDB No.1</div>
              </div>
              <div class="text-li">
                <div class="date">2018.09</div>
                <div class="content">Market-1501 No.1<br/>DukeMTMC-ReID No.1<br/>CUHK03 No.1</div>
              </div>
              <div class="text-li">
                <div class="date">2018.05</div>
                <div class="content">MOT17Det No.1</div>
              </div>
              <div class="text-li">
                <div class="date">2018.04</div>
                <div class="content">MOT15Det No.1</div>
              </div>
            </div>
          </div>
          <div class="development-course-item" :class="{'year-hidden': yearActive < 2017}">
            <div class="year">2017年</div>
            <div class="info">
              <div class="text-li">
                <div class="date">2017.04</div>
                <div class="content">MegaFace No.1</div>
              </div>
              <div class="text-li">
                <div class="date">2017.03</div>
                <div class="content">LFW No.1</div>
              </div>
              <div class="text-li">
                <div class="date">2017.03</div>
                <div class="content">ICDAR No.1</div>
              </div>
            </div>
          </div>
          <div class="development-course-item">
            <div class="year">2016年</div>
            <div class="info">
              <div class="only-text">腾讯行业贡献奖</div>
            </div>
          </div>
          <div class="development-course-item">
            <div class="year">2015年</div>
            <div class="info">
              <div class="text-li">
                <div class="date">2015.10</div>
                <div class="content">MIREX No.1在国际Pascal VOC2012物体分类赛刷新世界纪录</div>
              </div>
            </div>
          </div>
          <div class="development-course-item">
            <div class="year">2014年</div>
            <div class="info">
              <div class="text-li">
                <div class="date">2014.11</div>
                <div class="content">FDDB No.1</div>
              </div>
              <div class="text-li">
                <div class="date">2014</div>
                <div class="content">上海市科技进步二等奖</div>
              </div>
            </div>
          </div>
        </div>
        <div class="development-course-control">
          <div class="control-item" :class="{'year-active': yearActive === item}" v-for="(item, index) in yearArray" :key="index" @click="changeYear(item)">
            {{ item }}
          </div>
        </div>
      </div>
    </div>
    <div class="join-us" id="joinUs">
      <div class="module-title">加入我们</div>
      <div class="join-us-content">
        <div class="job-info">
          <div class="job-info-content">
            <div class="job-info-caption">职位信息</div>
            <div class="job-info-button-group">
              <div class="job-info-button" @click="handleJumpPage('https://careers.tencent.com/jobopportunity.html')">社会招聘<div class="job-detail-icon"></div></div>
              <div class="job-info-button" @click="handleJumpPage('https://careers.tencent.com/campusrecruit.html')">校园招聘<div class="job-detail-icon"></div></div>
            </div>
          </div>
        </div>
        <div class="other-info">
          <div class="work-environment" :style="{backgroundImage: 'url(' + currentWorkImageUrl + ')'}">
            <div class="work-environment-title">工作环境</div>
            <div class="environment-move-container">
              <div class="environment-move left-btn" :class="{'move-disabled-left': currentWorkImage <= 1}" @click="goImageLeft()"></div><div class="environment-move right-btn" :class="{'move-disabled-right': currentWorkImage >= 4}" @click="goImageRight()"></div>
            </div>
          </div>
          <div class="growth-welfare">
            <div class="growth-welfare-info">
              <div>成长与福利</div>
              <div class="growth-welfare-button" @click="handleJumpPage('https://careers.tencent.com/welfare.html')">了解详情<div class="growth-welfare-icon"></div></div>
              <!-- <div class="growth-welfare-detail" @click="handleJumpPage('https://careers.tencent.com/welfare.html')">了解详情</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const DEFAULTYEAR = 2025;
const LASTMOVEYEAR = 2016;
export default {
  name: 'aboutus',
  data() {
    return {
      honorLeft: 0,
      currentWorkImage: 1,
      currentWorkImageUrl: require('./img/img_gzhj1.jpg'),
      yearArray: [2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014],
      yearActive: DEFAULTYEAR
    };
  },
  mounted() {
    if (this.$route.query.key === 'joinus') {
      document.getElementById('joinUs').scrollIntoView();
    }
  },
  methods: {
    handleJumpPage(url, key) {
      if (url.indexOf('http') !== -1) {
        window.open(url, '_blank');
      }
    },
    changeYear(item) {
      this.yearActive = item;
      if (item >= LASTMOVEYEAR) {
        this.honorLeft = -[(DEFAULTYEAR - item) * 380];
      } else {
        this.honorLeft = -[(DEFAULTYEAR - LASTMOVEYEAR) * 380];
      }
    },
    goImageLeft() {
      if (this.currentWorkImage > 1) {
        this.currentWorkImage = this.currentWorkImage - 1;
        this.currentWorkImageUrl = require('./img/img_gzhj' + this.currentWorkImage + '.jpg');
      }
    },
    goImageRight() {
      if (this.currentWorkImage < 4) {
        this.currentWorkImage = this.currentWorkImage + 1;
        this.currentWorkImageUrl = require('./img/img_gzhj' + this.currentWorkImage + '.jpg');
      }
    }
  }
};
</script>

<style lang="less" scoped>
.aboutus-container {
  background-color: #ffffff;
  div{
    box-sizing: border-box;
  }
  .module-title {
    font-family: 'PingFangSC-Semibold';
    font-size: 28px;
    text-align: center;
    color: #000000;
    letter-spacing: 0;
    line-height: 42px;
    font-weight: 500;
  }
  .banner-container{
    width: 100%;
    color: #ffffff;
    background-image: url(./img/banner_aboutus_bg.jpg);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    margin-top: 60px;
    .banner-content{
      width: 1263px;
      height: 360px;
      padding-left: 30px;
      margin: 30px auto 0;
      .banner-title{
        font-size: 40px;
        font-family: 'PingFangSC-Medium';
        color: #000000;
        font-weight: 500;
        padding-top: 125px;
      }
      .banner-theme {
        font-size: 18px;
        color: #3D485D;
        text-align: justify;
        margin-top: 10px;
      }
    }
  }
  .youtu-profile-container {
    width: 100%;
    .youtu-profile-content {
      width: 1263px;
      margin: 120px auto;
      padding: 0 30px;
      font-size: 0;
      .youtu-profile {
        display: inline-block;
        width: 560px;
        height: 330px;
        vertical-align: top;
        margin-right: 62px;
        .profile-title {
          height: 42px;
          font-family: 'PingFangSC-Semibold';
          font-size: 28px;
          color: #000000;
          line-height: 42px;
          font-weight: 500;
        }
        .profile-info{
          font-size: 16px;
          color: #3D485D;
          line-height: 32px;
          text-align: justify;
          padding-top: 15px;
          >p {
            margin: 16px 0;
          }
        }
      }
      .youtu-video{
        display: inline-block;
        width: 580px;
        height: 330px;
        vertical-align: top;
        .player{
          width: 580px;
          height: 100%;
        }
      }
    }
  }
  .development-course-container {
    width: 100%;
    background: url('./img/img_fzls.jpg') center center no-repeat;
    background-size: cover;
    overflow-x: hidden;
    .development-course {
      width: 1263px;
      margin: 0 auto;
      padding: 60px 30px;
      .development-course-content {
        height: 400px;
        margin-top: 60px;
        font-size: 0;
        white-space: nowrap;
        position: relative;
        .development-course-item {
          width: 380px;
          height: 370px;
          display: inline-block;
          vertical-align: top;
          .year {
            font-family: 'PingFangSC-Semibold';
            font-size: 24px;
            color: #3D485D;
            font-weight: 600;
            margin-bottom: 10px;
          }
          .info {
            white-space: normal;
            .text-li {
              font-size: 14px;
              color: #3D485D;
              padding: 10px 0;
              .date{
                display: table-cell;
                width: 70px;
                height: 25px;
                font-weight: 500;
                opacity: 0.8;
                line-height: 25px;
              }
              .content {
                width: 225px;
                display: table-cell;
                line-height: 25px;
              }
            }
            .only-text {
              font-size: 14px;
              color: #3D485D;
              line-height: 25px;
              padding-top: 10px;
            }
          }
          &.year-hidden {
            opacity: 0;
          }
        }
      }
      .development-course-control {
        margin-top: 10px;
        display: flex;
        .control-item {
          flex: 1;
          font-size: 14px;
          color: #3D485D;
          height: 34px;
          line-height: 34px;
          opacity: 0.8;
          text-align: center;
          border-top: 1px solid rgba(61, 72, 93, 0.6);
          &.year-active {
            position: relative;
            top: -1px;
            font-family: 'PingFangSC-Semibold';
            opacity: 1;
            font-weight: 600;
            border-top: 3px solid #3D485D;
          }
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
  .join-us {
    width: 100%;
    padding-top: 120px;
    background-color: #ffffff;
    font-size: 0;
    .join-us-content {
      width: 1263px;
      margin: 0 auto;
      padding: 30px 30px 120px;
      .job-info {
        width: 590px;
        height: 590px;
        font-family: 'PingFangSC-Semibold';
        font-size: 20px;
        color: #FFFFFF;
        font-weight: 600;
        box-sizing: border-box;
        display: inline-block;
        vertical-align: top;
        background: url('./img/img_zwxx.jpg') center center no-repeat;
        background-size: cover;
        position: relative;
        .job-info-content {
          position: absolute;
          left: 20px;
          bottom: 30px;
          .job-info-caption {
            padding-left: 10px;
            margin-bottom: 10px;
          }
          .job-info-button-group {
            font-size: 14px;
            .job-info-button {
              display: inline-block;
              vertical-align: top;
              margin: 10px;
              padding-left: 20px;
              width: 121px;
              height: 36px;
              line-height: 34px;
              background: rgba(255,255,255,0.05);
              border: 1px solid rgba(255,255,255,0.6);
              position: relative;
              .job-detail-icon {
                width: 20px;
                height: 20px;
                position: absolute;
                right: 15px;
                top: 8px;
                background: url('./img/arrow_white.svg') center center no-repeat;
              }
              &:hover {
                cursor: pointer;
                background: rgba(255,255,255,0.30);
                border: 1px solid rgba(255,255,255,0.8);
              }
            }
          }
        }
        &:hover {
          background-size: 110% 110%;
        }
      }
      .other-info {
        width: 590px;
        height: 590px;
        box-sizing: border-box;
        display: inline-block;
        vertical-align: top;
        margin-left: 22px;
        .work-environment {
          height: 282px;
          font-family: 'PingFangSC-Semibold';
          font-size: 20px;
          color: #FFFFFF;
          font-weight: 600;
          /* background-image: url('./img/img_gzhj1.jpg'); */
          background-position: center center;
          background-repeat: no-repeat;
          background-size: cover;
          position: relative;
          .work-environment-title {
            line-height: 28px;
            position: absolute;
            top: 210px;
            left: 30px;
          }
          .environment-move-container {
            position: absolute;
            top: 210px;
            right: 20px;
            .environment-move {
              width: 40px;
              height: 40px;
              display: inline-block;
              margin: 0 10px;
              background: rgba(255,255,255,0.05);
              border: 1px solid rgba(255,255,255,0.6);
            }
            .left-btn {
              background: url("./img/arrow_white_l.svg") center center no-repeat;
              &:hover {
                cursor: pointer;
                /* background: url("./img/arrow_white_l.svg") center center no-repeat, linear-gradient(180deg, rgba(0,0,0,0.00) 50%, rgba(0,0,0,0.40) 100%), linear-gradient(135deg, rgba(0,128,255,0.06) 0%, rgba(0,128,255,0.03) 100%); */
                background-color: rgba(255,255,255,0.30);
              }
            }
            .right-btn {
              background: url("./img/arrow_white.svg") center center no-repeat;
              &:hover {
                cursor: pointer;
                background-color: rgba(255,255,255,0.30);
              }
            }
            .move-disabled-left {
              cursor: default;
              opacity: 0.4;
              pointer-events: none;
            }
            .move-disabled-right {
              cursor: default;
              opacity: 0.4;
              pointer-events: none;
            }
          }
        }
        .growth-welfare {
          height: 282px;
          margin-top: 26px;
          background: url('./img/img_czfl.jpg') center center no-repeat;
          background-size: cover;
          position: relative;
          font-family: 'PingFangSC-Semibold';
          font-size: 20px;
          color: #FFFFFF;
          font-weight: 600;
          .growth-welfare-info {
            position: absolute;
            left: 30px;
            bottom: 40px;
            .growth-welfare-button {
              margin-top: 20px;
              padding-left: 20px;
              width: 121px;
              height: 36px;
              font-size: 14px;
              line-height: 34px;
              background: rgba(255,255,255,0.05);
              border: 1px solid rgba(255,255,255,0.6);
              position: relative;
              .growth-welfare-icon {
                width: 20px;
                height: 20px;
                position: absolute;
                right: 15px;
                top: 8px;
                background: url('./img/arrow_white.svg') center center no-repeat;
              }
              &:hover {
                cursor: pointer;
                background: rgba(255,255,255,0.30);
                border: 1px solid rgba(255,255,255,0.8);
              }
            }
          }
          &:hover {
            background-size: 110% 110%;
          }
        }
      }
    }
  }
  @media (max-width: 2000px) {
    /* .honor-move {
      display: inline-block !important;
    } */
  }
  @media (min-width: 2000px) {
    /* .honor-move {
      display: none;
    } */
  }
  @media (min-width: 1600px) {
    /* .aboutus-honor {
      .aboutus-honor-content {
        .aboutus-honor-item {
          .aboutus-honor-img {
            &.rank {
              background-image: url('./img/icon_rank_2x.png');
            }
            &.top {
              background-image: url('./img/icon_top10_2x.png');
            }
            &.trophy {
              background-image: url('./img/icon_trophy_2x.png');
            }
            &.product {
              background-image: url('./img/icon_product_2x.png');
            }
            &.earth {
              background-image: url('./img/icon_earth_2x.png');
            }
          }
        }
      }
    }  */
  }
}
</style>


// WEBPACK FOOTER //
// src/components/open/panels/aboutus/Aboutus.vue